<div class="version" ng-click="vm.onClick(draft)"><a>{{draft.version}}</a></div>
<div class="user">{{draft.checkedOutBy.DisplayName}}</div>
<div class="checkedOut">{{draft.checkedOutAt | cDate : '' : 'medium' }}</div>
<div class="checkedIn">{{draft.checkedInAt | cDate  : '' : 'medium' }}</div>
<div class="size">{{draft.size | bytes}}</div>
<div class="filename">{{draft.filename}}</div>
